import axiosInstance from "./axiosInstance";

/**
 * Fetches a paginated list of customers.
 * @param {object} params - The query parameters for the request.
 * @param {number} params.page - The page number.
 * @param {number} params.pageSize - The number of items per page.
 * @param {string} [params.username] - The username to filter by.
 * @param {number} [params.streak] - The streak number to filter by.
 * @returns {Promise} The promise from the axios GET request.
 */
export const getCustomers = (params) => {
  const queryParams = { ...params, site: process.env.REACT_APP_SITE_ID };
  return axiosInstance.get("/customers", { params: queryParams });
};

/**
 * Updates the status of a specific customer.
 * @param {string} customerId - The ID of the customer to update.
 * @returns {Promise} The promise from the axios PATCH request.
 */
export const updateCustomerStatus = (customerId) => {
  // The interceptor will add 'site' to the body if needed by the API.
  return axiosInstance.patch(`/customers/update-status/${customerId}`);
};

/**
 * Fetches the details of a specific customer.
 * @param {string} customerId - The ID of the customer.
 * @returns {Promise} The promise from the axios GET request.
 */
export const getCustomerDetail = (customerId) => {
  // The interceptor will add 'site' to query params if needed by the API.
  return axiosInstance.get(`/customers/customer-detail/${customerId}`);
};
